var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4426_18610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49753 11V5.5M0.997532 7.1V9.4C0.997532 9.96005 0.997532 10.2401 1.10653 10.454C1.2024 10.6422 1.35538 10.7951 1.54354 10.891C1.75745 11 2.03748 11 2.59753 11H7.93853C8.66927 11 9.03464 11 9.32974 10.8663C9.58983 10.7484 9.81088 10.5588 9.96691 10.3196C10.1439 10.0483 10.1995 9.68718 10.3106 8.96494L10.5722 7.26494C10.7187 6.31234 10.792 5.83605 10.6506 5.46544C10.5266 5.14015 10.2932 4.86815 9.99057 4.69607C9.64577 4.5 9.16387 4.5 8.20006 4.5H7.79753C7.51751 4.5 7.37749 4.5 7.27054 4.4455C7.17646 4.39757 7.09997 4.32108 7.05203 4.227C6.99753 4.12004 6.99753 3.98003 6.99753 3.7V2.23292C6.99753 1.552 6.44554 1 5.76461 1C5.6022 1 5.45502 1.09565 5.38906 1.24406L3.70868 5.02491C3.63225 5.19688 3.59404 5.28286 3.53363 5.34591C3.48024 5.40164 3.41467 5.44425 3.34206 5.47041C3.25991 5.5 3.16582 5.5 2.97763 5.5H2.59753C2.03748 5.5 1.75745 5.5 1.54354 5.60899C1.35538 5.70487 1.2024 5.85785 1.10653 6.04601C0.997532 6.25992 0.997532 6.53995 0.997532 7.1Z",
    stroke: "#7BA4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4426_18610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 -1 12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpIcon);
export default __webpack_public_path__ + "static/media/thumbsUpIcon.6a222cea4945d1f12829768240947a90.svg";
export { ForwardRef as ReactComponent };